import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'

function AdminLayout() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <Outlet /> {/* This renders the nested route */}
        </Box>
    )
}

export default AdminLayout
